import $ from 'jquery';

export const $window = $(window);
export const $document = $(document);
export const $body = $('body');
